var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnchecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1246 -411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1246 411)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260.342 373.057)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.692,58.83,9.447,70.074a2.134,2.134,0,0,1-3.017,0L.624,64.269a2.133,2.133,0,0,1,3.017-3.017l4.3,4.3,9.736-9.736a2.133,2.133,0,0,1,3.017,3.017Z",
    transform: "translate(0 0)",
    fill: "#7c7c7c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.a4cf9d99bc6e6f79ec17b1cc6ea2cdd4.svg";
export { ForwardRef as ReactComponent };